import { TextFieldProps } from '@mui/material';
import { MuiTelInput, matchIsValidTel } from 'mui-tel-input';
import { useEffect, useRef } from 'react';
import { useController, useFormContext } from 'react-hook-form';
import { useLocale } from '../../contexts/locale.context';

type FormTextFieldProps = TextFieldProps & {
  name: string;
};

function handleWheel(event: WheelEvent) {
  event.preventDefault();
}

const FormTelField = ({ name, defaultValue = '', type, sx, ...rest }: FormTextFieldProps) => {
  const { lang } = useLocale();
  const { field } = useController({
    name,
    defaultValue,
    rules: { required: rest.required, validate: (v) => matchIsValidTel(v) },
  });
  const {
    formState: { errors, isSubmitted },
    setValue,
  } = useFormContext<{ [key: string]: string }>();
  const error = errors[name];

  const inputRef = useRef<HTMLInputElement>(null);

  useEffect(() => {
    const input = inputRef.current;
    if (input && type === 'number') {
      input.addEventListener('wheel', handleWheel, { passive: false });
    }
    return () => {
      input?.removeEventListener('wheel', handleWheel);
    };
  }, [inputRef, type]);

  return (
    <MuiTelInput
      fullWidth
      defaultCountry={lang === 'uk' || lang === 'ru' ? 'UA' : 'ES'}
      color="secondary"
      error={!!error}
      helperText={error?.message}
      {...field}
      {...rest}
      onChange={(v) => setValue(name, v.replace(/\s/g, ''))}
      sx={{
        bgcolor: (t) => t.palette.background.paper,
        boxShadow: 'none',
        borderRadius: 1,
        borderWidth: 2,
        mb: 2,
        ...sx,
      }}
    />
  );
};

export default FormTelField;
